export function calculateDiscount(price?: number, discountPercent?: number): number | undefined {
  if (price == null) return undefined;
  if (!discountPercent) return price;
  return price - (price * discountPercent) / 100;
}
